import React, { memo, useContext, useEffect, useMemo, useState } from 'react';
import { useStyles } from '../../../LawPortal.styles';
import {
  ButtonLink,
  MTable,
  //  MTable,
  //   Panel,
  //    RepealableName,
  Transition
} from '../../../../../Components';
import { useIntl } from 'react-intl';
import {
  Button,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Tooltip,
  //  IconButton,
  // LinearProgress,
  // Theme,
  // Tooltip,
  //  Typography,
  // createStyles,
  // withStyles
} from '@material-ui/core';
import {
  ArchiveOutlined,
  // ArrowForward,
  ArrowRightAlt,
  DoneOutline,
  Edit,
  // ControlPointDuplicate,
  //  Delete,
  //   DoneOutline,
  //    Edit,
  ExpandMore,
  Unarchive,
  UnarchiveOutlined,
  //  PlaylistAdd,
  //   SyncDisabledSharp,
  //    SyncSharp
} from '@material-ui/icons';
import { CreateDirectCompliance } from "./CreateDirectCompliance";
import { ModuleContext } from '../../../../../Context/ModuleContext/ModuleContext';
import {
  AccessLevel,
  LawPortalFeature,
  Module,
  // PlanFeature,
  UserContext
} from "../../../../../Context/UserContext/UserContext";
import { useAptorApi } from "../../../../../Api";
import { Title } from "../../../../../Components/Panel/Panel";
import PlanningViewLK from "./View/PlanningViewLK";
import moment from "moment";
import { useComplianceState } from "./List/ComplianceState";
import { ExecuteFilter } from "./ExecuteFilter";
import { useFilter } from "../../../../../Components/ListFilter";
import { useHistory, useLocation } from "react-router-dom";
import { MTableToolbar } from 'material-table';
import { useSnackbar } from 'notistack';
import { useConfirmation } from '../../../../../Context/ConfirmationContext/ConfirmationContext';
// import async from "react-select/async";
// import async from "react-select/async";
// import { Link } from "react-router-dom";
// import { useComplianceSession } from "../../../../../Context/ComplianceSessionContext";
// import { PublishedWithChanges, Unpublished } from '@mui/icons-material';
interface IconProps {
  id: number;
  icon?: React.ReactNode;
  onClick?: () => void;
}
interface BorderLinearProgressProps {
  name: string; // Define the type of the name prop
  variant: 'determinate' | 'indeterminate' | 'buffer' | 'query';
  value: number;
}
export const CarryLK = () => {
  const {
    // enableCompliance,
    // complianceEnabled,
    // disableCompliance,
    startComplianceSession,
    // hasCompliance,
    // isComplianceUserFor,
    // toggleCompliance,
    setLawsSelectedForCompliance,
    toggleCompliance,
    setPlan,
    setPLanEdit
  } = useComplianceState();
  // const {
  //   clearComplianceSession,
  //   complianceSession
  // } = useComplianceSession();
  // const tableRef = React.createRef();
  const classes = useStyles();
  const [createvisible, setcreateVisible] = useState(false);
  const { customerId } = useContext(UserContext)
  const { api, abortController } = useAptorApi();
  const [directPlanLoading, setDirectPlanLoading] = useState(false)
  const [planData, setPlanData] = useState([])
  const [directPlan, setDirectPlanData] = useState([])
  const [expendDirectPlanPanel, setExpendDirectPlanPanel] = useState("")
  const [expendPlanPanel, setExpendPlanPanel] = useState("")
  let { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);
  const { hasAccessToModule,hasAccessToFeature } = useContext(UserContext);
  const [filters, setFilter] = useFilter();
  const [search, setSearch] = useState("")
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [allcontrol, setAllControl] = useState([])
  const history = useHistory()
  const [archivePlan, setArchivePlan] = useState([])
  const { deleteConfirmation } = useConfirmation();
  const { enqueueSnackbar } = useSnackbar()
  useEffect(() => {
    var menu = []
    if (hasAccessToModule(Module.Administration) || hasAccessToModule(Module.Organization)) {
      menu = [
        {
          title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.planning.lek' }),
          to: `/law-portal/legal-compliance-control/planning`,
        },
        {
          title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.carry.lek' }),
          to: `/law-portal/legal-compliance-control/carry`,
        },
        {
          title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.lek' }),
          to: `/law-portal/legal-compliance-control/reports`,
        },
      ]
    } else {
      menu = [
        {
          title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.carry.lek' }),
          to: `/law-portal/legal-compliance-control/carry`,
        },
        {
          title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.lek' }),
          to: `/law-portal/legal-compliance-control/reports`,
        },
      ]
    }
    setHeader(formatMessage({ id: 'law-portal.legal.compliance.header', defaultMessage: 'Legal compliance control' }), menu);
  }, [setHeader, formatMessage, expendPlanPanel, expendDirectPlanPanel]);
  useEffect(() => {
    const queryParamsMap = {
      tags: 'tags',
      companyUnit: 'companyUnit',
      complianceUsers: 'complianceUsers',
      processes: 'processes',
      aspects: 'aspects',
      category: 'category',
      area: 'area',
    };
    const searchQuery = queryParams.getAll('search')
    if (searchQuery.length) {
      setSearch(searchQuery[0])
    }
    Object.entries(queryParamsMap).forEach(([queryKey, stateKey]) => {
      const queryValues = queryParams.getAll(queryKey);
      if (queryValues.length) {
        setFilter(stateKey, queryValues.join(',').split(',').map(num => num.toString()));
      }
    });
  }, []);

  const [startCompliance, setStartCompliance] = useState(false)
  const getplanLaws = async (planData: any) => {
    await api.getPlanLawsexecute(planData.id).then((response: any) => {
      if (response?.length == 0 || response == null) {

        enqueueSnackbar(formatMessage({ id: 'evelution-all-error-msg' }, { companyunitname: planData?.customerCompanyUnitId?.name }), { variant: 'error' })
      }
      setPlan(planData)
      setLawsSelectedForCompliance(response)
      setStartCompliance(true)
    })
  }
  const getPlanRequirement = async (planData: any) => {
    await api.getPlanrequirementexecute(planData.id).then((response: any) => {
      if (response?.length == 0 || response == null) {
        enqueueSnackbar(formatMessage({ id: 'evelution-all-error-msg' }, { companyunitname: planData?.customerCompanyUnitId?.name }), { variant: 'error' })
      }
      setPlan(planData)
      setLawsSelectedForCompliance(response)
      setStartCompliance(true)
    })
  }
  const handleComplianceSession = async (event: any, planData: any) => {
    event.stopPropagation();
    if (planData?.planData?.type === 1) {
      await getPlanRequirement(planData)
    } else {
      await getplanLaws(planData)
    }
    setStartCompliance(false)
  }
  useEffect(() => {
    startComplianceSession()
  }, [startCompliance])
  const archiveconfirmation = {
    title: formatMessage({ id: 'component.plan-change.archive.label' }),
    description: formatMessage({ id: 'component.plan-change.archive.confirmation' }),
  };
  const unarchiveconfirmation = {
    title: formatMessage({ id: 'component.plan-change.archive.label' }),
    description: formatMessage({ id: 'component.plan-change.unarchive.confirmation' }),
  };
  const handleArchive = (planData: any) => {
    // deleteConfirmation(ack, confirmation);

    const onReplace = async () => {
      await api.updatePlan(planData?.id, { isArchived: true })
      handleAllControl()
      return getComplianceDirectPlan()
    };

    const onCancel = () => { };

    deleteConfirmation(
      onReplace,
      archiveconfirmation,
      onCancel,
    );
  }
  const handleunArchive = (planData: any) => {
    const onReplace = async () => {
      await api.updatePlan(planData?.id, { isArchived: false })
      handleAllControl()
      return getComplianceDirectPlan()
    };

    const onCancel = () => { };

    deleteConfirmation(
      onReplace,
      unarchiveconfirmation,
      onCancel,
    );
  }
  const IconsNode = memo(({ planData, activeTab }: any) => {
    return (
      <>
        {activeTab === 'complete' ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '7px' }}>
            <Tooltip title={formatMessage({ id: "law-portal.unarchive" })}>
              <div onClick={() => handleunArchive(planData)}>
                <UnarchiveOutlined style={{ cursor: 'pointer' }} />
              </div>
            </Tooltip>
          </div>
        ) : (
          <Grid style={{ display: 'flex', gap: '10px' }} item>
            <Tooltip title={formatMessage({ id: "law-portal.archive" })}>
              <div onClick={() => handleArchive(planData)}>
                <ArchiveOutlined style={{ cursor: 'pointer' }} />
              </div>
            </Tooltip>
            {planData?.lawCount > 0 && planData.isExecutionVisible && <Button variant="contained" type="submit" onClick={(event: any) => handleComplianceSession(event, planData)} >
              <ArrowRightAlt />
              {formatMessage({ id: "law-portal.compliance-law.execute.evaluation-for-all" })}
            </Button>}
          </Grid>
        )}
        {/* <Grid item>
          <Button startIcon={<ArrowForward />} component={Link} to={nextLawInCompliance?.complianceUrl}>
            <FormattedMessage
              id="law-portal.our-laws.table.continue-compliance-session.button"
              defaultMessage="Continue compliance session"
            />
          </Button>
        </Grid> */}
      </>
    );
  });


  useEffect(() => {
    getComplianceDirectPlan()
  }, [filters, search])
  const getComplianceDirectPlan = async () => {
    setDirectPlanLoading(true);
    await api.getAllcompliancePlan(customerId, { filters: filters, search: search }).then((response: any) => {
      if (!abortController.current.signal.aborted) {
        const plan = response?.customerPlans?.filter((val: any) => !val.isDirect && val.isActive && !val.isArchived)
        const directPlan = response?.customerPlans?.filter((val: any) => val.isDirect && !val.isArchived)
        plan?.sort((a: any, b: any) => {
          const startDateComparison = new Date(b.startDate).getTime() as number - new Date(a.startDate).getTime() as number
          if (startDateComparison === 0) {
            return a.name.localeCompare(b.name);
          }

          return startDateComparison;
        });
        directPlan?.sort((a: any, b: any) => {
          const startDateComparison = new Date(b.startDate).getTime() as number - new Date(a.startDate).getTime() as number
          if (startDateComparison === 0) {
            return a.name.localeCompare(b.name);
          }

          return startDateComparison;
        });
        const archivePlan = response?.customerPlans?.filter((val: any) => val.isArchived)
        archivePlan?.sort((a: any, b: any) => {
          const startDateComparison = new Date(b.startDate).getTime() as number - new Date(a.startDate).getTime() as number
          if (startDateComparison === 0) {
            return a.name.localeCompare(b.name);
          }

          return startDateComparison;
        });
        setPlanData(plan)
        setDirectPlanData(directPlan)
        setArchivePlan(archivePlan)
        setDirectPlanLoading(false);
      }
    }).catch(() => {
      setDirectPlanLoading(false);
    })
  }


  useEffect(() => {
    var itemCount = localStorage.length
    for (var i = 0; i < itemCount; i++) {
      var key: any = localStorage.key(i);
      if (key) {
        const checkCompliance = key.split(/[_-]/)[0]
        if (checkCompliance === "compliance" || checkCompliance === "ComplianceSession") {
          localStorage.removeItem(key)
        }
      }
    }
  }, [])
  useEffect(() => {
    setExpendDirectPlanPanel("")
    setExpendPlanPanel("")
  }, [filters, search])
  useEffect(() => {
    var updatedQueryParams = Object.keys(filters)
      .filter(key => filters[key]?.join() !== undefined && filters[key]?.join() !== "")
      .map(key => `${key}=${encodeURIComponent(filters[key]?.join())}`)
      .join('&');
    if (search !== "") {
      updatedQueryParams = `${updatedQueryParams}&search=${search}`
    }
    history.push({
      pathname: '',
      search: `?${updatedQueryParams}`,
    });
  }, [filters, history, search]);


  const { firstName, lastName } = useContext(UserContext);
  const currentuserName = `${firstName} ${lastName}`

  const handleComplianceSessionnew = async (event: any, lawData: any) => {
    let lawDatanew = { planid: lawData.id, ...lawData }
    lawDatanew.id = lawData?.legislationId
    setStartCompliance(true)
    event.stopPropagation();
    setPlan(lawData)
    await toggleCompliance(lawDatanew)
    setStartCompliance(false)
  }
  const handleEditSession = async (lawData: any) => {
    let lawDatanew = { planid: lawData.id, ...lawData }
    lawDatanew.id = lawData?.legislationId
    setStartCompliance(true)
    setPlan(lawData)
    setPLanEdit(true)
    await toggleCompliance(lawDatanew)
    setStartCompliance(false)
  }
  const handlemsg = () => {
    enqueueSnackbar(formatMessage({ id: 'component.law-error-description' }), {
      variant: 'error',
    });
  }
  const allplan: any = [
    { title: formatMessage({ id: 'law-portal.our-laws.table.number' }), field: 'number', sorting: false },
    {
      title: formatMessage({ id: 'law-portal.our-laws.table.law' }),
      field: 'legislation',
      sorting: false,

    },
    { title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }), field: 'name', sorting: false },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
      field: 'customerCompanyUnitId',
      render: (row: any) => row?.customerCompanyUnitId?.name,
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
      field: 'startDate',
      render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }), field: 'endDate',
      render: (row: any) => row?.endDate ? moment(row?.endDate).format('YYYY-MM-DD') : "-", sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Recuring-interval' }),
      field: 'recurrentInterval',
      render: (row: any) => row?.recurrentInterval || "-",
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance.report.table.col' }),
      field: 'responsibles',
      render: (row: any) => {
        if (row.responsibles) {
          const responsiblearr = row?.responsibles?.split(',')
          return (
            <>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {responsiblearr?.map((val: any) => {
                  return <span>{val}</span>
                })}
              </div>
            </>
          )
        } else {
          return "-"
        }
      },
      sorting: false,
      width: "20%"
    },
    {
      title: '',
      field: '',
      render: (row: any) => {
        const responsible = row?.responsibles?.split(',')
        responsible?.forEach((item: any, index: any, array: any) => {
          array[index] = item.toLowerCase();
        });
        return (
          <>
            {responsible?.includes(currentuserName.toLowerCase()) ? row.isStarted ?
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '7px' }}>
                {/* <Tooltip title={formatMessage({ id: "law-portal.our-law.compliance.complete" })}>
                  <DoneOutline style={{ cursor: 'pointer' }} />
                </Tooltip> */}
                <Tooltip title={formatMessage({ id: "law-portal.our-law.compliance.edit" })}>
                  <Edit style={{ cursor: 'pointer' }} onClick={() => row?.hasAccessToExecute == 0 ? handlemsg() : handleEditSession(row)} />
                </Tooltip>
              </div>
              : <Button
                variant="contained"
                onClick={(event: any) => row?.hasAccessToExecute == 0 ? handlemsg() : handleComplianceSessionnew(event, row)}
              >
                {row?.type === 1 ? formatMessage({ id: "law-portal.our-laws.compliance.tab.carryout.kek.create.button" }) : formatMessage({ id: "law-portal.our-laws.compliance.tab.carryout.create.button" })}
              </Button> : ""}
          </>
        );
      },
    },
  ]

  const [activeTab, setActiveTab] = useState<any>('ongoing-plan')
  const columnplan = useMemo(() => [
    { title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }), field: 'name' },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
      field: 'customerCompanyUnitId',
      render: (row: any) => row?.customerCompanyUnitId?.name,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
      field: 'startDate',
      render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
      sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }), field: 'endDate',
      render: (row: any) => row?.endDate ? moment(row?.endDate).format('YYYY-MM-DD') : "-", sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Recuring-interval' }),
      field: 'recurrentInterval',
      render: (row: any) => row?.recurrentInterval || "-",
      sorting: false,
    },
    {
      title: formatMessage({
        id: 'utils.filters.status',
      }),
      field: 'status',
      render: (row: any) => `${row.executedLawCount} ${formatMessage({ id: 'text.of' })} ${row.lawCount} ${formatMessage({ id: 'status.text' })} `,
      sorting: false,
    },
    {
      title: "",
      field: '',
      render: (row: any) =>
        <>
          <IconsNode planData={row} activeTab={activeTab} />
        </>,
      sorting: false,
    },
  ], [activeTab])
  const tableRef = React.createRef();
  const [column, setColumn] = useState(columnplan)


  const handleAllControl = async () => {
    const allcompliance: any = await api.getAllcompliancePlanAllControl<any>(customerId, {
      search: search,
      filters: filters
    });

    if(hasAccessToFeature(LawPortalFeature.Statistics, AccessLevel.Read)){
      setAllControl(allcompliance?.filter((data: any) => data?.isActive == true&& data.isArchived!==true))
    }else{
      setAllControl(allcompliance?.filter((val: any) => {
        const responsible = val?.responsibles?.split(',')
        responsible?.forEach((item: any, index: any, array: any) => {
          array[index] = item.toLowerCase();
        });
        if (responsible?.includes(currentuserName.toLowerCase())&&val?.isActive == true&& val.isArchived!==true) {
          return val
        }
    }))
    }
  }

  useEffect(() => {
    handleAllControl()
  }, [filters, search])
  const handleAll = () => {
    setColumn(allplan)
    setActiveTab('all')
  }
  return (
    <div className={classes.listWrapper}>
      {createvisible ?
        <ButtonLink text={formatMessage({ id: "component.back-button.back" })} to={''} onclick={() => setcreateVisible(false)} />
        :
        <ButtonLink text={formatMessage({ id: "law-portal.legal.complaince.create.new.compliance.direct" })} to={''} onclick={() => setcreateVisible(true)} />
      }
      <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
      {createvisible ?
        <CreateDirectCompliance getComplianceDirectPlan={getComplianceDirectPlan} handleAllControl={handleAllControl} setcreateVisible={setcreateVisible} />
        :
        <>
          <ExecuteFilter filters={filters} setFilter={setFilter} search={search} setSearch={(value: any) => setSearch(value)} />
          <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
          <Transition isLoading={directPlanLoading}>
            {activeTab == 'all' ?
              <MTable
                tableRef={tableRef}
                columns={column}
                // data={updateLaws !== "" && updateLaws == planLawsData.id?handleDataFetch:getPlanlaws}
                data={allcontrol}
                options={{
                  detailPanelColumnAlignment: 'right'
                }}
                components={{
                  Toolbar: (props) => <div className={classes.toolbar} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex' }}>
                      <div className={`${classes.tabsize} ${activeTab === "ongoing-plan" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                        setActiveTab('ongoing-plan')
                        setColumn(columnplan)
                      }}>{formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.continuously' })}<span className={classes?.tabNumber}>{planData?.length}</span></div>
                      <div className={`${classes.tabsize} ${activeTab === "ongoing-direct" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                        setActiveTab('ongoing-direct')
                        setColumn(columnplan)
                      }}>{formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.ongoing' })}<span className={classes?.tabNumber}>{directPlan?.length}</span></div>
                      <div className={`${classes.tabsize} ${activeTab == "all" ? classes?.tabActive : classes?.tab}`} onClick={() => handleAll()} >{formatMessage({ id: 'law-portal.compliance-law.direct_plan-compliance.all-control' })}<span className={classes?.tabNumber}>{allcontrol?.length}</span></div>
                      <div className={`${classes.tabsize} ${activeTab == "complete" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                        setActiveTab('complete')
                        setColumn(columnplan)
                      }}>{formatMessage({ id: 'lawportal.evalution.completed.compliance.tab' })}<span className={classes?.tabNumber}>{archivePlan?.length}</span></div>


                    </div>
                    <MTableToolbar {...props} />

                  </div>
                }}
              /> :
              <MTable
                tableRef={tableRef}
                columns={columnplan}
                data={activeTab == 'complete' ? archivePlan : activeTab == "ongoing-plan" ? planData : directPlan}
                options={{
                  detailPanelColumnAlignment: 'right'
                }}
                components={{
                  Toolbar: (props) => (
                    <div className={classes.toolbar} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex' }}>
                        <div className={`${classes.tabsize} ${activeTab == "ongoing-plan" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                          setActiveTab('ongoing-plan');
                        }}>
                          {formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.continuously' })}<span className={classes?.tabNumber}>{planData?.length}</span>
                        </div>
                        <div className={`${classes.tabsize} ${activeTab == "ongoing-direct" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                          setActiveTab('ongoing-direct');
                        }}>
                          {formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.ongoing' })}<span className={classes?.tabNumber}>{directPlan?.length}</span>
                        </div>
                        <div className={`${classes.tabsize} ${activeTab == "all" ? classes?.tabActive : classes?.tab}`} onClick={() => handleAll()}>
                          {formatMessage({ id: 'law-portal.compliance-law.direct_plan-compliance.all-control' })}<span className={classes?.tabNumber}>{allcontrol?.length}</span>
                        </div>
                        <div className={`${classes.tabsize} ${activeTab == "complete" ? classes?.tabActive : classes?.tab}`} onClick={() => {
                          setActiveTab('complete');
                        }}>
                          {formatMessage({ id: 'lawportal.evalution.completed.compliance.tab' })}<span className={classes?.tabNumber}>{archivePlan?.length}</span>
                        </div>
                      </div>
                      <MTableToolbar {...props} />
                    </div>
                  ),
                }}
                detailPanel={[
                  {
                    tooltip: formatMessage({ id: "text.expend" }),
                    render: (rowData: any) => {
                      return <PlanningViewLK planData={rowData} filters={{}} search={search} activeTab={activeTab} />
                    },
                  }
                ]}
              />

            }
          </Transition>
        </>
      }
    </div>
  );
}
